// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EventCoverageCheckParams } from './eventCoverageCheckParams';

/**
 * Request model for event coverage check job
 */
export interface RunEventCoverageCheckJobRequest {
  type: 'event_coverage_check';
  params: EventCoverageCheckParams;
  allowOverlappingJobs?: boolean;
}
